<app-notification></app-notification>

<router-outlet></router-outlet>

<!-- Global Modal Component -->
<app-modal></app-modal>
